// extracted by mini-css-extract-plugin
export default {"zhightest":"Quality_zhightest__UiIij"};